export const MOBILE_NAV_HEIGHT = 54;

/** UserDefaults (iOS) / Preferences (Android) storage key */
export const PN_OPT_IN_STORAGE_KEY = 'pushNotificationOptInShown';
/** Show the pre prompt max times */
export const PN_OPT_IN_SHOW_MAX = 4;
export const MOBILE_APP_ID = 'com.bridebook.mobileapp';

// Height a page reserves at the bottom for its sticky bar, above the safe area
export const STICKY_BOTTOM_BAR_HEIGHT = 80;
